<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.group_index,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: $tc('messages.grades', 2) + ' (' + $t('messages.overview') + ')',
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex space-x-2 items-center">
            <NavLinks :links="meta.navLinks.trimester" />
        </div>

        <div class="md:grid md:grid-cols-3 md:gap-6 mt-5">
            <div class="col-span-2">
                <div class="flex flex-col">
                    <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                        <div
                            class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                        >
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead>
                                    <tr>
                                        <th
                                            class="max-w-xs px-2 py-1 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $t('messages.student') }}
                                        </th>
                                        <th
                                            class="max-w-xs px-1 py-1 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                            v-for="range in letters"
                                            :key="range"
                                        >
                                            {{ range }}
                                        </th>
                                        <th
                                            class="max-w-xs px-1 py-1 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                            v-for="category in categories"
                                            :key="category.id"
                                            :title="category.name"
                                        >
                                            {{ category.short_name }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                        v-for="(student, index) in students"
                                        :key="student.id"
                                    >
                                        <td
                                            class="max-w-sm truncate px-2 py-1 whitespace-nowrap text-sm leading-5 text-gray-900"
                                        >
                                            <span :title="student.full_name">
                                                {{ student.first_name_and_initial }}
                                            </span>
                                        </td>
                                        <td
                                            class="px-1 py-1 whitespace-nowrap text-sm leading-5 text-gray-500 text-center"
                                            v-for="range in student.graded_ranges"
                                        >
                                            <span :class="{ 'text-gray-300': range === 0 }">{{ range }}</span>
                                        </td>
                                        <td
                                            class="px-1 py-1 whitespace-nowrap text-sm leading-5 text-center"
                                            :class="score.classes"
                                            v-for="score in student.scores"
                                        >
                                            {{ score[display] }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="grid grid-cols-2 md:gap-6">
                    <div v-for="category in categories" :key="category.id">
                        <div class="text-sm text-gray-500">
                            {{ category.name }}
                        </div>
                        <div>
                            <apexchart
                                :type="charts.pieChart.chart.type"
                                :height="charts.pieChart.chart.height"
                                :series="category.pie_series"
                                :options="charts.pieChart"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div>
                <apexchart
                    :type="charts.barChart.chart.type"
                    :height="charts.barChart.chart.height"
                    :series="charts.barChart.series"
                    :options="charts.barChart"
                />
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        PanelPage,
        NavLinks,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'group', 'categories', 'pie_chart', 'students', 'letters', 'bar_chart'],
    data() {
        return {
            display: 'letter',
            charts: {
                pieChart: JSON.parse(JSON.stringify(this.pie_chart)),
                barChart: JSON.parse(JSON.stringify(this.bar_chart)),
            },
        };
    },
};
</script>
